import React from "react";
import Select, { components } from "react-select";

export const ValueContainer = ({ children, hasValue, ...props }) => (
  <components.ValueContainer {...props}>
    {
      props.isMulti && hasValue && children[0].length > 1
        ? [<span style={{ color: 'white', fontFamily: "Roboto-Light, Arial, sans-serif" }} key={children[0].length}>{props.selectProps.moreThenOneText + " (" + children[0].length + ")"}</span>, children[1]]
        : children
    }
  </components.ValueContainer>
);
export default class SelectReact extends React.Component {
  render() {
    const { data, selectedOption, disabled, ...props } = this.props;
    return (
      <Select
        isClearable={true}
        {...props}
        options={data}
        value={selectedOption}
        isDisabled={disabled}
        style={{ cursor: "pointer" }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Select.jsx